import React from 'react'
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import WelcomeCard from "./WelcomeCard";
import DashboardTask from "../task/DashboardTask";
import AnalyticsDashboard from "../reports/AnalyticsDashboard";
import TodayOverview from "./TodayOverview";
import QuickStartActions from "./QuickActions";
import HomeDailyPlannerWidget from "./HomeDailyPlannerWidget";
import {useNavigate} from "react-router-dom";
import {useAuth} from '../authentication/AuthContext';
import {useStats} from '../reports/hooks/useStats';
import {useDueRecallCardCount} from '../recall/hooks/useRecall';

const EMPTY_STATS = {
    completedTasks: 0,
    completedPomodoros: 0,
    focusSeconds: 0,
};

function Homepage() {
    const navigate = useNavigate();
    const {authToken, isLoading: authLoading} = useAuth();
    const {data: recallDue = 0} = useDueRecallCardCount(authToken);
    const dailyQuery = useStats(authToken, 'DAILY');
    const weeklyQuery = useStats(authToken, 'WEEKLY');
    const monthlyQuery = useStats(authToken, 'MONTHLY');
    const allTimeQuery = useStats(authToken, 'ALL_TIME');

    const statsByRange = {
        DAILY: dailyQuery.data ?? EMPTY_STATS,
        WEEKLY: weeklyQuery.data ?? EMPTY_STATS,
        MONTHLY: monthlyQuery.data ?? EMPTY_STATS,
        ALL_TIME: allTimeQuery.data ?? EMPTY_STATS,
    };

    const isLoadingByRange = {
        DAILY: authLoading || dailyQuery.isLoading,
        WEEKLY: authLoading || weeklyQuery.isLoading,
        MONTHLY: authLoading || monthlyQuery.isLoading,
        ALL_TIME: authLoading || allTimeQuery.isLoading,
    };

    const hasErrorByRange = {
        DAILY: Boolean(dailyQuery.error),
        WEEKLY: Boolean(weeklyQuery.error),
        MONTHLY: Boolean(monthlyQuery.error),
        ALL_TIME: Boolean(allTimeQuery.error),
    };

    return (
        <div className="flex min-h-screen flex-col bg-[var(--bg)]">
            <Header/>
            <div className="flex flex-1 gap-3 bg-[var(--workspace-bg)] px-3 pb-4 pt-[76px] md:gap-4 md:px-4">
                <Sidebar/>
                <main className="flex min-w-0 flex-1 flex-col rounded-[10px] bg-[var(--surface)]">
                    <div className='p-4'>
                        <WelcomeCard/>
                    </div>
                    {/*<DailyFlow completed={["Plan", "Focus"]} />*/}
                    <div className='p-4'>
                    <QuickStartActions/>
                    </div>
                    {/* Row for two dashboards */}
                    <div className='p-4'>
                    <TodayOverview
                        recallDue={recallDue}
                        statsByRange={statsByRange}
                        isLoadingByRange={isLoadingByRange}
                        hasErrorByRange={hasErrorByRange}
                    />
                    </div>
                    <div className='p-4'>
                       <HomeDailyPlannerWidget />
                    </div>
                    {/*<ProjectsSnapshot/>*/}
                    <div className="flex h-auto flex-col gap-4 bg-[var(--page-bg)] p-4 lg:h-[400px] lg:flex-row">
                        {/* Tasks dashboard */}
                        <div className="w-full lg:w-1/2">
                            <div className="ml-0 mt-2 h-[360px] rounded-[8px] border border-[var(--border-color)] bg-[var(--surface)] shadow-[var(--menu-shadow)] lg:ml-4">
                                <div className="flex items-center justify-between">
                                    <h2 className="pl-4 pt-4 text-xl font-semibold text-[var(--text-primary)]">Tasks</h2>
                                    <button
                                        onClick={() => navigate('/task')}
                                        className="mr-4 mt-4 text-xs font-medium text-[var(--text-muted)] transition-colors hover:text-[var(--brand-coral)]"
                                    >
                                        View all →
                                    </button>
                                </div>
                                <div className="scroll-y min-w-0 pr-2">
                                    <DashboardTask/>
                                </div>
                            </div>
                        </div>
                        {/* Analytics dashboard */}
                        <div className="w-full lg:w-1/2">
                            <AnalyticsDashboard />
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
}

export default Homepage;
